module.exports = __webpack_public_path__ + "static/media/Bitso.706ba853.svg";